import Vue from 'vue'
import Router from 'vue-router'

/* Route Modules */
import Index from '../pages/Index'
import Newspaper from './routes/newspaper.route'
import NewspaperPreview from './routes/newspaperpreview.route'
import Login from './routes/login.route'
import Introduction from './routes/introduction.route'
import Regulation from './routes/regulation.route'
import ExportImage from '../pages/ExportImage'
import multiguard from 'vue-router-multiguard'
import authGuard from '../guards/auth.guard'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/newspaper/',
  routes: [
    {
      path: '',
      redirect: '/Introduction',
      name: 'Index',
      component: Index,
      children: [
        Newspaper,
        NewspaperPreview,
        Login,
        Introduction,
        Regulation,
        {
          path: 'export',
          name: 'ExportImage',
          component: ExportImage,
          meta: {
            title: 'Page Title'
          },
          beforeEnter: multiguard([authGuard])
        }
      ]
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
